export default __webpack_public_path__ + "static/background-02-4cf949b4f30ebe7f9d8d6183be09deb6.svg";